import React, { useEffect, useState } from 'react'
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal } from "../../../NumberFormat";
const BetPopup = (props) => {
  const { status, bettype, date, gameId, limitId, period, transId } = props;
  const [transectionDetailData, setTransectionDetailsData] = useState([]);
  const [gameCode, setGameCode] = useState('');
  const [totalBuyers, setTotalBuyers] = useState(0);
  const [infoBetType, setInfoBetType] = useState({});
  const device = useSelector(state => state.CommonConfig.device_type);

  // api for Transection History Detail
  const featchTransectionHistoryDetail = () => {
    let reqData = {
      act: status,
      bettype: bettype,
      date: date.split(' ')[0],
      game_id: gameId,
      limitid: limitId,
      period: parseInt(period),
      trans_id: transId,
      type: 'winlose'

    };
    makeAjax(url.PLAYER_API.getTransaction, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setTransectionDetailsData(response.data.result ? response.data.result : response.data);
      setGameCode(response.data.game.game_code)
      setInfoBetType(response.data.infoBetType);
      // Calculate total buyers
      if (response.data.result) {
        const total = response.data.result.reduce((accumulator, currentValue) => {
          return accumulator + parseFloat(currentValue.bayar);
        }, 0);
        setTotalBuyers(total.toFixed(2));
      }

    });
  };


  useEffect(() => {
    featchTransectionHistoryDetail();
  }, []);
  return (
    <div className='trasaction_popup'>

      {/* table */}
      <div className="informasi_tble_result">
        {device === "Desktop" ?
          <table >
            <thead>
              <tr>
                <th>{props.t("period")}</th>
                <th>{props.t("bet")}</th>
                {
                  (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                    infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                    infoBetType.BET_TYPE_KOMBINASI === bettype ||
                    infoBetType.BET_TYPE_QUICKBUY === bettype ||
                    infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                  <th>{props.t("bet")}2</th>
                }
                {
                  (
                    infoBetType.BET_TYPE_QUICKBUY === bettype ||
                    infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                  <th>{props.t("bet")}3</th>
                }
                {
                  (
                    infoBetType.BET_TYPE_QUICKBUY === bettype ||
                    infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                  <th>{props.t("position")}</th>
                }
                <th>{props.t("amount")}</th>
                <th>{props.t("discount")} %</th>
                <th>
                  {infoBetType.BET_TYPE_5050 === bettype ||
                    infoBetType.BET_TYPE_50502D === bettype ||
                    infoBetType.BET_TYPE_TENGAHTEPI === bettype ||
                    infoBetType.BET_TYPE_DASAR === bettype ||
                    infoBetType.BET_TYPE_SILANGHOMO === bettype ||
                    infoBetType.BET_TYPE_KEMBANGKEMPIS === bettype ? `${props.t("kei")} %` : props.t("prize")
                  }
                </th>
                <th>{props.t("total_amount")}</th>
                <th>{props.t("x_win")}</th>
                <th>{props.t("description")}</th>
              </tr>
            </thead>
            <tbody>
              {transectionDetailData.length === undefined ? (
                <tr className='table_data_empty_row'>
                  <td colSpan="8">{props.t("data_not_found")}</td>
                </tr>
              ) : (
                transectionDetailData.map((value, index) => (

                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td>{`${parseInt(period)}-${gameCode}`}</td>
                    <td>{value.bet}</td>
                    {
                      (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                        infoBetType.BET_TYPE_KOMBINASI === bettype ||
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                      <td>{value.bet2}</td>
                    }
                    {
                      (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                      <td>{value.bet3}</td>
                    }
                    {
                      (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                      <td>{value.posisi}</td>
                    }
                    <td>{formatPricewithdecimal(value.amount)}</td>
                    <td>{value.disc}</td>
                    <td>{formatPricewithdecimal(value.prizekei)}</td>
                    <td>{formatPricewithdecimal(value.bayar)}</td>
                    <td>{formatPricewithdecimal(value.win_amount)}</td>
                    <td>{value.info}</td>
                  </tr>
                )))}
            </tbody>

          </table> : <>

            {transectionDetailData.length == 0 ?
              <div className='invoice_tbl_container'>
                <p className='no_data'>{props.t("data_not_found")}</p>
              </div>
              : <div className='invoice_tbl_container'>
                {transectionDetailData.map((value, index) => (
                  <div className='invoice_tbl'>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("period")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {period}-{gameCode}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("bet")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.bet}
                      </div>
                    </div>
                    {
                      (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                        infoBetType.BET_TYPE_KOMBINASI === bettype ||
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("bet")}2</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.bet2}
                        </div>
                      </div>
                    }
                    {
                      (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("bet")}3</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.bet3}
                        </div>
                      </div>
                    }
                    {
                      (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                      <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                          <p>{props.t("position")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                          {value.posisi}
                        </div>
                      </div>
                    }
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("amount")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {formatPricewithdecimal(value.amount)}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("discount")} %</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.disc}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{infoBetType.BET_TYPE_5050 === bettype ||
                          infoBetType.BET_TYPE_50502D === bettype ||
                          infoBetType.BET_TYPE_TENGAHTEPI === bettype ||
                          infoBetType.BET_TYPE_DASAR === bettype ||
                          infoBetType.BET_TYPE_SILANGHOMO === bettype ||
                          infoBetType.BET_TYPE_KEMBANGKEMPIS === bettype ? `${props.t("kei").charAt(0).toUpperCase() + props.t("kei").slice(1)} %` : props.t("prize")
                        }</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.prizekei}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("total_amount")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {formatPricewithdecimal(value.bayar)}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("x_win")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {formatPricewithdecimal(value.win_amount)}
                      </div>
                    </div>
                    <div className={`invoice_tbl_row `} >
                      <div className='invoice_clmn1'>
                        <p>{props.t("desc")}</p>
                      </div>
                      <div className='invoice_clmn2'>
                        {value.info}
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            } </>}
        <div className='total_price_div'>
          {props.t("total")}: {formatPricewithdecimal(totalBuyers)}
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(BetPopup)